import React from 'react';
import { PropertyGroup } from '../PropertyGroup';
import { PropertyNumber } from '../property-types/PropertyNumber';

interface SpacingData {
  paddingTop: number;
  paddingRight: number;
  paddingBottom: number;
  paddingLeft: number;
  marginTop: number;
  marginRight: number;
  marginBottom: number;
  marginLeft: number;
}

interface SpacingGroupProps {
  spacing: SpacingData;
  onSpacingChange: (property: keyof SpacingData, value: number) => void;
}

export const SpacingGroup: React.FC<SpacingGroupProps> = ({
  spacing,
  onSpacingChange
}) => {
  return (
    <PropertyGroup title="Spacing">
      {/* Padding */}
      <div className="space-y-0.5 mt-1">
        <div className="flex items-center gap-2 py-0.5">
          <span className="text-gray-900 dark:text-white text-sm font-medium w-[30%] flex-shrink-0">Padding</span>
          <div className="flex flex-1 gap-1">
            <PropertyNumber
              label="T"
              value={spacing.paddingTop}
              onChange={(value) => onSpacingChange('paddingTop', value)}
              step={1}
              min={0}
              suffix="px"
            />
            <PropertyNumber
              label="R"
              value={spacing.paddingRight}
              onChange={(value) => onSpacingChange('paddingRight', value)}
              step={1}
              min={0}
              suffix="px"
            />
          </div>
        </div>
        <div className="flex items-center gap-2 py-0.5">
          <span className="w-[30%]"></span>
          <div className="flex flex-1 gap-1">
            <PropertyNumber
              label="B"
              value={spacing.paddingBottom}
              onChange={(value) => onSpacingChange('paddingBottom', value)}
              step={1}
              min={0}
              suffix="px"
            />
            <PropertyNumber
              label="L"
              value={spacing.paddingLeft}
              onChange={(value) => onSpacingChange('paddingLeft', value)}
              step={1}
              min={0}
              suffix="px"
            />
          </div>
        </div>
      </div>

      {/* Margin */}
      <div className="space-y-0.5">
        <div className="flex items-center gap-2 py-0.5">
          <span className="text-gray-900 dark:text-white text-sm font-medium w-[30%] flex-shrink-0">Margin</span>
          <div className="flex flex-1 gap-1">
            <PropertyNumber
              label="T"
              value={spacing.marginTop}
              onChange={(value) => onSpacingChange('marginTop', value)}
              step={1}
              suffix="px"
            />
            <PropertyNumber
              label="R"
              value={spacing.marginRight}
              onChange={(value) => onSpacingChange('marginRight', value)}
              step={1}
              suffix="px"
            />
          </div>
        </div>
        <div className="flex items-center gap-2 py-0.5">
          <span className="w-[30%]"></span>
          <div className="flex flex-1 gap-1">
            <PropertyNumber
              label="B"
              value={spacing.marginBottom}
              onChange={(value) => onSpacingChange('marginBottom', value)}
              step={1}
              suffix="px"
            />
            <PropertyNumber
              label="L"
              value={spacing.marginLeft}
              onChange={(value) => onSpacingChange('marginLeft', value)}
              step={1}
              suffix="px"
            />
          </div>
        </div>
      </div>
    </PropertyGroup>
  );
};

